import React from "react";
import ReactModal from "react-modal";
import "../set-metrics-modal/set-metrics-modal.scss";
import { Form } from "react-bootstrap";

class SetMetricsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: null,
            is_submitted: false,
        };
    }

    componentDidMount = () => {
        if (this.props?.user?.channel == "sales_channel") {
            this.setState(
                {
                    selectedItems: [
                        {
                            name: "Approved",
                            id: [18, 20],
                            color: "#44AE42",
                            avgPerc: 0,
                        },
                    ],
                    metrics: [
                        {
                            name: "Approved",
                            id: [18, 20],
                            color: "#44AE42",
                            avgPerc: 0,
                        },
                        {
                            name: "Working Lead",
                            id: [1, 4],
                            color: "#819FEC",
                            avgPerc: 0,
                        },
                        {
                            name: "App in Progress",
                            id: [5, 9],
                            color: "#7FCECE",
                            avgPerc: 0,
                        },
                        {
                            name: "Unworkable",
                            id: [10, 13],
                            color: "#F0BE74",
                            avgPerc: 0,
                        },
                        {
                            name: "Underwriting",
                            id: [14, 17],
                            color: "#E7B8DF",
                            avgPerc: 0,
                        },
                        {
                            name: "Declined",
                            id: [21, 22],
                            color: "#FF4F4F",
                            avgPerc: 0,
                        },
                    ],
                },
                () => {
                    this.setState({
                        selectedItems: this.props.selectedStatuses,
                    });
                },
            );
        } else {
            this.setState(
                {
                    selectedItems: [
                        {
                            name: "Approved",
                            id: 12,
                            color: "#44AE42",
                            avgPerc: 0,
                        },
                    ],
                    metrics: [
                        {
                            name: "Approved",
                            id: 12,
                            color: "#44AE42",
                            avgPerc: 0,
                        },
                        {
                            name: "Pre-Bank Review",
                            id: 8,
                            color: "#819FEC",
                            avgPerc: 0,
                        },
                        {
                            name: "Underwriting Review",
                            id: 9,
                            color: "#7FCECE",
                            avgPerc: 0,
                        },
                        {
                            name: "In Consideration",
                            id: 10,
                            color: "#F0BE74",
                            avgPerc: 0,
                        },
                        {
                            name: "Awaiting Reserve",
                            id: 11,
                            color: "#E7B8DF",
                            avgPerc: 0,
                        },
                        {
                            name: "Denied",
                            id: 13,
                            color: "#FF4F4F",
                            avgPerc: 0,
                        },
                        {
                            name: "Cancelled",
                            id: 14,
                            color: "#660000",
                            avgPerc: 0,
                        },
                    ],
                },
                () => {
                    this.setState({
                        selectedItems: this.props.selectedStatuses,
                    });
                },
            );
        }
    };
    handleChangeMultiple = (position, e) => {
        e.persist();
        let items = this.state.metrics.map((item, index) => {
            if (position === index) {
                const found = this.state.selectedItems.some((el) =>
                    _.isEqual(el.id, item.id),
                );
                if (!found && e.target.checked) {
                    this.setState((prev) => ({
                        selectedItems: [...prev.selectedItems, item],
                    }));
                } else {
                    var filter = this.state.selectedItems.filter((obj) => {
                        return !_.isEqual(obj.id, item.id);
                    });
                    this.setState((prev) => ({
                        selectedItems: filter,
                    }));
                }
            }
        });
    };
    handleChange = (position, e) => {
        e.persist();
        let items = this.state.metrics.map((item, index) => {
            if (position === index) {
                const found = this.state.selectedItems.some(
                    (el) => el.id === item.id,
                );
                if (!found && e.target.checked) {
                    this.setState((prev) => ({
                        selectedItems: [...prev.selectedItems, item],
                    }));
                } else {
                    var filter = this.state.selectedItems.filter((obj) => {
                        return obj.id !== item.id;
                    });
                    this.setState((prev) => ({
                        selectedItems: filter,
                    }));
                }
            }
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.updateSelectedStatuses(this.state.selectedItems);
        this.props.closeModal();
    };

    checkIfSelected = (id) => {
        let selected = false;
        this.props.selectedStatuses.forEach((item) => {
            if (item.id == id) {
                selected = true;
            }
        });
        return selected;
    };
    checkIfSelectedMultiple = (id) => {
        let selected = false;
        this.props.selectedStatuses.forEach((item) => {
            if (_.isEqual(id, item.id)) {
                selected = true;
            }
        });
        return selected;
    };
    render() {
        return (
            <ReactModal isOpen={this.props.show} className="app-metrics-modal">
                <div className="modal-header">
                    <h4 className="text-left">
                        Application Processing metrics
                    </h4>
                </div>
                <div className="modal-cancel" onClick={this.props.closeModal}>
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <Form
                        id="set-goal-form"
                        onSubmit={(e) => this.handleSubmit(e)}
                        autoComplete="off"
                    >
                        <p>Set metrics</p>

                        {this.props?.user?.channel == "sales_channel" ? (
                            <>
                                {this?.state?.metrics?.map((item, index) => (
                                    <>
                                        <Form.Check
                                            key={item.id}
                                            defaultChecked={
                                                _.isEqual([18, 20], item.id)
                                                    ? true
                                                    : this.checkIfSelectedMultiple(
                                                          item.id,
                                                      )
                                            }
                                            disabled={
                                                _.isEqual([18, 20], item.id)
                                                    ? true
                                                    : false
                                            }
                                            type="checkbox"
                                            value={item.id}
                                            label={item.name}
                                            name="label[]"
                                            id={item.id}
                                            onChange={(e) =>
                                                this.handleChangeMultiple(
                                                    index,
                                                    e,
                                                )
                                            }
                                        />
                                    </>
                                ))}
                            </>
                        ) : (
                            <>
                                {this?.state?.metrics?.map((item, index) => (
                                    <>
                                        <Form.Check
                                            key={item.id}
                                            defaultChecked={
                                                item.id == 12
                                                    ? true
                                                    : this.checkIfSelected(
                                                          item.id,
                                                      )
                                            }
                                            disabled={
                                                item.id == 12 ? true : false
                                            }
                                            type="checkbox"
                                            value={item.id}
                                            label={item.name}
                                            name="label[]"
                                            id={item.id}
                                            onChange={(e) =>
                                                this.handleChange(index, e)
                                            }
                                        />
                                    </>
                                ))}
                            </>
                        )}
                    </Form>
                </div>
                <div className="modal-footer">
                    <button
                        form="set-goal-form"
                        type="submit"
                        className="btn confirm-button"
                    >
                        {" "}
                        Confirm{" "}
                    </button>
                    <button
                        className="btn cancel-button"
                        onClick={this.props.closeModal}
                    >
                        {" "}
                        Cancel{" "}
                    </button>
                </div>
            </ReactModal>
        );
    }
}

export default SetMetricsModal;
